<!--
 * @Author: xiaokun
 * @Date: 2020-03-04 09:29:35
 * @LastEditors: xiaokun
 * @LastEditTime: 2020-03-09 16:54:36
 * @Description: 原创/转载文章底部 新增活码开关
 -->
<template>
  <div class="activity-code-switch">
    <mk-switch
      v-model="isCodeOpen"
      active-color="#009CFF"
      inactive-color="#E5E5E5"
      @change="checkoutCodeSwitch"
    >
    </mk-switch>
    <div v-if="isCodeOpen">
      <p class="switch-tips">
        活码在文章末尾展示，扫描后可自动分配销售跟进
      </p>
      <!-- 活码选择 -->
      <mk-select
        v-model="activityCode"
        placeholder="选择企业客服活码"
        width="220"
        @change="selectActivity"
      >
        <mk-option
          v-for="item in activityCodeList"
          :key="item._id"
          :label="item.name"
          :value="item._id"
        >
        </mk-option>
      </mk-select>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ActivityCodeSwitch',
  components: {},
  props: {
    dialogData: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      // 活码开关是否开启
      isCodeOpen: false,
      // 活码列表
      activityCodeList: [],
      // 当前选择活码
      activityCode: '',
      // 活码是否可用
      isEnable: true
    }
  },
  watch: {},
  created () {
    // 初始化活码回显
    this.init()
  },
  mounted () {
  },
  methods: {
    init () {
      // 营销资料带有活码，编辑时回显.
      if (this.dialogData.qrCodeInfo.qrCodeId) {
        // 活码可用
        if (this.dialogData.qrCodeInfo.isEnable) {
          this.isCodeOpen = true
          // 将当前 回显选中的 id 传回父级
          this.selectActivity(this.dialogData.qrCodeInfo.qrCodeId)
          // 下拉框回显
          this.activityCode = this.dialogData.qrCodeInfo.qrCodeId
        } else {
          // 活码不可用
          this.isEnable = false
        }
      }
      this.getComponyCodeList()
    },
    // 选中活码，将选中id提交至父级
    selectActivity (_id) {
      this.$emit('activity-code', _id)
    },
    // 改变活码开关状态，当活码为关闭时，清除传递至父级的活码id，为了提交编辑时，不将当前原有id带回
    checkoutCodeSwitch (val) {
      if (!val) {
        this.$emit('activity-code', '')
      }
      if (val && !this.isEnable) {
        this.$emit('is-enable-code', false)
      }
    },
    // 获取企业活码列表
    async getComponyCodeList () {
      let params = {
        page: this.page,
        pageSize: 10,
        isEnable: true
      }
      let res = await MKMATERIALSVC.QrCodeApi.qrcodeListMiniGet(params)
      if (res.success) {
        this.total = res.data.total
        this.activityCodeList = res.data.data
      }
    }
  }
}
</script>
<style scoped lang="scss">
.activity-code-switch {
  .switch-tips {
    color: #888;
    font-size: 12px;
    line-height: 1;
    padding: 8px 0;
  }
}
</style>
